import { SearchDictInterface } from '@/shared/components/searchEngine';
import { RootState } from '@/store/store';
import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { LocalPreferences, StickerDraft } from '@/types/search';

export const defaultPreferences: LocalPreferences = {
  search: {},
  showAIChecksOnSinglePlagCheck: false,
  showPlagChecksOnSingleAICheck: false,
};

const localPreferenceSlice = createSlice({
  name: 'localPreferences',
  initialState: defaultPreferences,
  reducers: {
    setSearchPreferences: (state: LocalPreferences, { payload }: PayloadAction<SearchDictInterface>) => {
      state.search = payload;
    },
    setLocalPreferences(state: LocalPreferences, { payload }: PayloadAction<LocalPreferences>) {
      return payload;
    },
    resetPreferences: () => defaultPreferences,
    setShowAIChecksOnSinglePlagCheck(state: LocalPreferences, { payload }: PayloadAction<boolean>) {
      state.showAIChecksOnSinglePlagCheck = payload;
    },
    setShowPlagChecksOnSingleAICheck(state: LocalPreferences, { payload }: PayloadAction<boolean>) {
      state.showPlagChecksOnSingleAICheck = payload;
    },
    setActiveSidebars(state: LocalPreferences, { payload }: PayloadAction<string[]>) {
      state.activeSidebars = payload;
    },
    addStickerDraft(state: LocalPreferences, { payload }: PayloadAction<StickerDraft>) {
      const drafts = [...(state.stickerDrafts?.map((obj) => ({ ...obj })) || [])];

      const targetDraft = drafts.find(({ idType, idEntity }) => idType === payload.idType && idEntity === payload.idEntity);

      console.log('TARGET DRAFT EXISTS!!!!', targetDraft, payload, drafts);

      if (targetDraft) {
        state.stickerDrafts = drafts.map((draft) => {
          if (draft.idType === payload.idType && draft.idEntity === payload.idEntity) {
            return {
              ...draft,
              text: payload.text,
              idFiles: payload.idFiles,
            };
          }
          return draft;
        });
      } else {
        state.stickerDrafts = [...drafts, payload];
      }
    },
    removeStickerDraft(state: LocalPreferences, { payload }: PayloadAction<Pick<StickerDraft, 'idType' | 'idEntity'>>) {
      state.stickerDrafts = (state.stickerDrafts || []).filter(
        ({ idType, idEntity }) => idType !== payload.idType && idEntity !== payload.idEntity,
      );
    },
  },
});

export const {
  setSearchPreferences,
  resetPreferences,
  setLocalPreferences,
  setShowAIChecksOnSinglePlagCheck,
  setShowPlagChecksOnSingleAICheck,
  setActiveSidebars,
  addStickerDraft,
  removeStickerDraft,
} = localPreferenceSlice.actions;

export const searchPreferencesSelector = ({ localPreferences }: RootState): SearchDictInterface | undefined => localPreferences.search;

export const showAIChecksOnSinglePlagCheckSelector = ({ localPreferences }: RootState) => localPreferences.showAIChecksOnSinglePlagCheck;

export const showPlagChecksOnSingleAICheckSelector = ({ localPreferences }: RootState) => localPreferences.showPlagChecksOnSingleAICheck;

export const sidebarActiveKeysSelector = ({ localPreferences }: RootState) => localPreferences.activeSidebars || [];

export const stickerDraftSelector = ({ localPreferences }: RootState) => localPreferences.stickerDrafts || [];

export default localPreferenceSlice.reducer;
